import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import smoothscroll from 'smoothscroll-polyfill';

import renderAndInitializeMainApp from 'Jsx/Utils/renderAndInitializeMainApp';

import AegisLayout from 'aegisv2/Layout';
import LayoutV2 from 'Jsx/Shared/LayoutV2';
import { createStore } from 'Jsx/Utils';
import InitI18n from 'Shared/InitI18n';

import Catalog from './containers';
import theme from './ui/theme';
import getInitialState from './getInitialState';
import rootReducer from './rootReducer';

smoothscroll.polyfill();
window.__forceSmoothScrollPolyfill__ = true; // eslint-disable-line no-underscore-dangle

const { user, color_theme: colorTheme } = window.__INITIAL_STATE__;
const reduxPreloadState = window.__REDUX_PRELOAD_STATE__;

let initialState = {};

if (reduxPreloadState) {
  initialState = reduxPreloadState;
  delete window.__REDUX_PRELOAD_STATE__;
} else {
  // btw catalog already has a 'country_prefix' key
  initialState = getInitialState(
    window.__INITIAL_STATE__.catalog,
    user,
    window.__INITIAL_STATE__,
  );
}

const store = createStore({
  initialState,
  rootReducer,
});

const renderApp = () => {
  renderAndInitializeMainApp(
    <Provider store={store}>
      <LayoutV2 colorTheme={colorTheme}>
        <ThemeProvider theme={theme}>
          <AegisLayout>
            <InitI18n
              component={Catalog}
              initialI18nStore={initialState.translations}
              initialLanguage={initialState.currentLanguage}
            />
          </AegisLayout>
        </ThemeProvider>
      </LayoutV2>
    </Provider>,
    document.getElementById('mainNode'),
  );
};

renderApp();
